<template>
    <div :style="oracle.isMobile() ? 'width: 100%;' : 'width: 80%'">
        <v-dialog scrollable width="500" v-model="showForm">
            <v-card>
                <v-card-text v-if="form != null">
                    <div class="d-flex flex-column mt-3 mb-3">
                        <div class="border-bottom" :key="index" v-for="(item, index) in form.record_form[0]">
                            <span class="mt-2" style="color: #999999; font-size: 12px">{{item.title}}</span>
                            <div v-if="item.flag != null">
                                <span class="font-weight-bold">{{item.options[item.flag].title}}</span>
                            </div>
                        </div>
                    </div>
                    <base-button tag="span" @click="showForm = false"
                                 type="secondary" class="mb-2 mt-2">
                        {{language.lang('Discard')}}
                    </base-button>
                </v-card-text>
            </v-card>
        </v-dialog>
        <base-button v-if="subscriptions != null" tag="span"
                     @click="createContract()"
                     class="mb-5"
                     :style="oracle.isMobile() ? 'width : 100%' : ''"
                     :class="isEN ? 'mr-auto' : 'ml-auto'"
                     type="primary"
                     icon="fa fa-plus-circle">
            {{language.lang("Create a new client")}}
        </base-button>
        <div class="d-flex flex-row align-content-center mb-3" v-for="(item, index) in subscriptions" :key="index">
            <img v-if="!isLawyer" :class="'shadow-lg--hover review-avatar ' + (isEN? 'mr-2' : 'ml-2')"
                 :src="item.lawyer != null && item.lawyer.lawyer_cover != null ? item.lawyer.lawyer_cover :
                                 require('@/assets/image/user_avatar.png')"
                 alt="">
            <img v-else :class="'shadow-lg--hover review-avatar ' + (isEN? 'mr-2' : 'ml-2')"
                 :src="item.user != null && item.user.user_avatar != null ? item.user.user_avatar :
                                 require('@/assets/image/user_avatar.png')"
                 alt="">
            <div class="d-flex flex-column flex">
                <v-card v-ripple style="padding: 10px 20px">
                    <div @click="item.expand = !item.expand" :style="oracle.isMobile() ? '' : 'align-items: center; align-content: center;'"
                         style="width: 100%; " class="d-flex" :class="!oracle.isMobile() ? 'flex-row' : 'flex-column'">
                        <div class="d-flex flex-column">
                            <h6 class="font-weight-bold">{{isLawyer ? item.user.username :
                                item.lawyer.lawyer_title}}</h6>
                            <h6 v-if="isLawyer" class="font-weight-bold"
                                style="font-size: 11px; margin-bottom: 0 !important; direction: ltr !important;">
                                {{item.user.phone !=
                                null ? ('+98' + item.user.phone.substring(1)) : item.user.email}}</h6>
                        </div>
                        <div :style="oracle.isMobile() ? 'margin-top : 10px; margin-bottom : 10px;' : ''"
                             class="d-flex flex-column "
                             :class="isEN && !oracle.isMobile() ? 'ml-auto text-right' : 'mr-auto text-left'">
                            <h6 v-if="isLawyer" style="margin-bottom: 0 !important; color: #00aff0"
                                class="font-weight-bold">
                            <span style="font-weight: normal !important; font-size: 12px; ">
                                <i class="fa fa-info-circle"></i>
                                {{getState(item.state)}}</span>
                            </h6>
                            <h6 v-if="item.hasPlan && isLawyer" style="margin-bottom: 0 !important; color: #3aaf85"
                                class="font-weight-bold">
                            <span style="font-weight: normal !important; font-size: 12px; ">
                                                                <i class="fa fa-check-circle"></i>
                                {{oracle.format(item.count) + language.lang("Has Plan")}}</span>
                            </h6>
                            <h6 @click="openForm(item)" v-if="item.hasForm && isLawyer"
                                style="margin-bottom: 0 !important; color: #f8cf00"
                                class="font-weight-bold">
                            <span class="text-underline" style="font-weight: normal !important; font-size: 12px; ">
                                <i class="fa fa-envelope-open "></i>
                                {{oracle.format(item.count) + language.lang("View Evaluation Form")}}</span>
                            </h6>
                            <base-button v-if="!isLawyer" :class="!isEN ? 'float-left' : 'float-right'" tag="span"
                                         @click="openLawyer(item)"
                                         :style="oracle.isMobile() ? 'width : 100%' : ''"
                                         type="success" class="mb-2 mt-2">
                                {{language.lang('Get in touch')}}
                            </base-button>
                        </div>
                        <i v-if="isLawyer" class="fa"
                           :class="(item.expand ? ' fa-chevron-up ' : ' fa-chevron-down ')
                            + (oracle.isMobile() ? '' : (isEN ? 'ml-3 mr-1' : 'mr-3 ml-1'))"></i>
                    </div>
                    <div class="d-flex flex-column" v-if="item.expand && isLawyer">
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-select :items="steps"
                                              v-model="item.state"
                                              item-text="abbr"
                                              item-value="state"
                                              :hint="language.lang('Set client state')"
                                              persistent-hint>
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-textarea
                                            :label="language.lang('Brief details about the current progress')"
                                            v-model="item.note">
                                    </v-textarea>
                                </v-col>
                            </v-row>
                        </v-container>
                        <div>
                            <base-button :class="!isEN || oracle.isMobile() ? 'float-left' : 'float-right'"
                                         v-if="isLawyer"
                                         :style="oracle.isMobile() ? 'width : 100%' : ''"
                                         tag="span" @click="saveItem(item)"
                                         type="default" class="mb-2 mt-2">
                                {{language.lang('Save changes')}}
                            </base-button>
                            <base-button :class="!isEN || oracle.isMobile() ? 'float-left' : 'float-right'"
                                         v-if="isLawyer"
                                         :style="oracle.isMobile() ? 'width : 100%' : ''"
                                         tag="span" @click="createContract(item)"
                                         type="success" class="mb-2 mt-2 mr-2">
                                {{language.lang('Create Contract')}}
                            </base-button>
                        </div>
                    </div>
                </v-card>
            </div>
        </div>
        <Placeholder v-if="subscriptions != null && subscriptions.length == 0"></Placeholder>
        <v-progress-circular v-if="subscriptions == null" color="#00aff0" indeterminate class="m-5 text-center"></v-progress-circular>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";
    import language from "@/utils/language";
    import Placeholder from "@/views/global/Placeholder";

    export default {
        components: {Placeholder},
        props: {
            lawyer: Object,
        },
        data: () => ({
            oracle: oracle,
            form: null,
            contract: {},
            showForm: false,
            language: language,
            isEN: oracle.isEN(),
            subscriptions: null,
            selectedClient: null,
            selectedPlan: null,
            steps: [
                {state: 0, abbr: language.lang('Pending')},
                {state: 1, abbr: language.lang('Cancel')},
                {state: 2, abbr: language.lang('Contract')},
                {state: 3, abbr: language.lang('No reply')},
            ],
            isLawyer: oracle.isLawyer()
        }), methods: {
            openLawyer(item) {
                this.$router.push({name: 'lawyer', params: {id: item.lawyer.lawyer_index}})
            }, getState(item) {
                for (let i = 0; i < this.steps.length; i++) {
                    if (this.steps[i].state == item) {
                        return this.steps[i].abbr
                    }
                }
                return null
            },
            translate(state) {
                for (let i = 0; i < this.steps.length; i++) {
                    if (this.steps[i].state == state) {
                        return this.steps[i].abbr
                    }
                }
                return ''
            }, openForm(item) {
                oracle.axios('lawyer/getConnectionForm', {record_id: item.record_id}, (res) => {
                    this.form = res.data
                    this.showForm = true
                })
            }, saveItem(item) {
                oracle.axios('lawyer/updateContact', item, (res) => {
                    oracle.showMessage(res.message, null, null, 'checked');
                    item.expand = false
                })
            }, fetch() {
                oracle.axios('lawyer/getConnections', {limit_by: 1000}, (res) => {
                    for (let i = 0; i < res.data.length; i++) {
                        res.data[i].expand = false
                    }
                    this.subscriptions = res.data
                })
            }, createContract(item) {
                oracle.send(oracle.CONTRACT, item)
            },
        },
        mounted() {
            oracle.receive(oracle.UPDATE, () => {
                this.fetch()
            })
            this.fetch()
        }
    };
</script>
<style>
</style>
